module.exports = __webpack_public_path__ + "img/members-icon.ad111c1d.svg";